export {
    default,
    type IntegrationSideContentTemplateProps,
} from './IntegrationSideContentTemplate';
